'use strict';
define([
    'angular',
    'modules/settings/partnersArea/partnersArea.controller'
],function(angular, PartnersAreaController){
    var app = angular.module('settings.partnersArea', []);
    app.controller('PartnersAreaController', PartnersAreaController);
    return app;
});